import React from 'react'
import { Toaster } from 'sonner'

import { useTheme } from '#hooks/useTheme'

/**
 * The app's toasts. They follow the app's own light/dark choice (the theme toggle),
 * not the operating system's, so a toast never flashes in the other scheme.
 * Render it inside ThemeProvider.
 */
export const ToastProvider = (): React.JSX.Element => {
  const { resolvedTheme } = useTheme()

  return (
    <Toaster
      position="top-right"
      richColors
      theme={resolvedTheme}
      toastOptions={{
        duration: 4000,
      }}
    />
  )
}
